import React from 'react'

import Iframe from 'react-iframe'

const FormExterno = (props) => {

    return (

        <>

            <Iframe url={props.src}
                width="100%"
                height="677px"
                id="frame"
                className="myClassname"
                display="initial"
                position="relative" />

        </>
    )

}

export default FormExterno